import { Assets } from 'pixi.js';

import { PrepScribeForEditorSuccessAction } from 'js/actionCreators/scribeActions';
import { ACCOUNT_TYPES, FILE_CONTENT_TYPES } from 'js/config/consts';
import { isImageElement } from 'js/editor/EditorCanvas/helpers/canvasElementHelpers';
import ScribeImageElementModel from 'js/models/ScribeImageElementModel';
import { ExistingScribeModel } from 'js/types';
import watermark from 'imgs/url-loaded/vs-watermark.svg';
import { AuthSuccessAction } from 'js/actionCreators/authActions';
import { ASSET_LOAD_OPTIONS } from 'js/playback/pixi-player/consts';

export function loadSvgAssets({
  imageElements,
  project
}: {
  imageElements: ScribeImageElementModel[];
  project: ExistingScribeModel;
}) {
  const svgAssets = imageElements
    .filter(imageElement => {
      return imageElement.image?.contentType === FILE_CONTENT_TYPES.SVG;
    });

  svgAssets.forEach(svgElement => {
    const src = svgElement._imageUrl;
    if (src) {
      Assets.load(
        {
          src,
          data: { type: 'splitSVG', element: svgElement, project }
        },
        ASSET_LOAD_OPTIONS
      );
    }
  });
}

export function loadGifAssets(imageElements: ScribeImageElementModel[]) {
  const gifAssets = imageElements
    .filter(imageElement => {
      return imageElement.image?.contentType === FILE_CONTENT_TYPES.GIF;
    });

  gifAssets.forEach(gifElement => {
    const src = gifElement._imageUrl;
    if (src) {
      Assets.load(
        {
          src,
          parser: 'gifLoader'
        },
        ASSET_LOAD_OPTIONS
      );
    }
  });
}

export function loadRasterAssets(imageElements: ScribeImageElementModel[]) {
  const rasterAssets = imageElements
    .filter(imageElement => {
      const contentType = imageElement.image?.contentType;
      return contentType && contentType !== FILE_CONTENT_TYPES.SVG && contentType !== FILE_CONTENT_TYPES.GIF;
    });

  rasterAssets.forEach(rasterElement => {
    const src = rasterElement._imageUrl;
    if (src) {
      Assets.load({ src, parser: 'texture' }, ASSET_LOAD_OPTIONS);
    }
  });
}

export function loadWatermark(action: AuthSuccessAction) {
  if (action.user.accountType === ACCOUNT_TYPES.FREE || action.user.accountType === ACCOUNT_TYPES.LITE) {
    Assets.load({ src: watermark, parser: 'svg' }, ASSET_LOAD_OPTIONS);
  }
}

export function* preloadPlaybackAssets(action: PrepScribeForEditorSuccessAction) {
  const project = action.scribe;
  const imageElements = project.elements
    .filter(element => {
      return isImageElement(element);
    });

  loadSvgAssets({ imageElements, project });
  loadGifAssets(imageElements);
  loadRasterAssets(imageElements);
}
